import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const EmptyState = ({ onClearFilters }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      paddingY={8}
      textAlign="center"
    >
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          backgroundColor: theme.palette.grey[100],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 3,
        }}
      >
        <SearchOffIcon
          sx={{
            fontSize: 60,
            color: theme.palette.grey[400],
          }}
        />
      </Box>

      <Typography
        variant="h5"
        fontWeight={600}
        color="text.primary"
        marginBottom={1}
      >
        No Results Found
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        marginBottom={3}
        maxWidth={400}
      >
        We couldn't find any driving schools or car dealers in the selected location.
        Try searching in a different city or state.
      </Typography>

      {onClearFilters && (
        <Button
          variant="outlined"
          color="primary"
          onClick={onClearFilters}
          sx={{ borderRadius: 2 }}
        >
          Clear Filters
        </Button>
      )}
    </Box>
  );
};

EmptyState.propTypes = {
  onClearFilters: PropTypes.func,
};

export default EmptyState;
